import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'EIN' })
export class EINPipe implements PipeTransform {
    transform(value: string, args: string[]): any {
        
            // if (!value) return value;
            
            // return [value.slice(0,2),'-',value.slice(3,value.length)].join('');
            
            



        if (!value) return value;

        return [value.slice(0, 2), '-', value.slice(2, value.length)].join('');


        // value.toUpperCase();

        // return value.replace(/\w\S*/g, function (txt) {
        //     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        // });
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/app.EIN.pipe.ts